import { renderer as advanced_copy_block } from './sections/advancedCopyBlock/advancedCopyBlock';
import { renderer as button } from './sections/button/button';
import { renderer as content_tiles } from './sections/contentTiles/contentTiles';
import { renderer as copy_block } from './sections/copyBlock/copyBlock';
import { renderer as department_hero_banner } from './sections/departmentHeroBanner/departmentHeroBanner';
import { renderer as hero_carousel } from './sections/heroCarousel/heroCarousel';
import { renderer as links_block } from './sections/linksBlock/linksBlock';
import { renderer as membership_banner } from './sections/membershipBanner/membershipBanner';
import { renderer as page_carousel } from './sections/pageCarousel/pageCarousel';
import { renderer as partner_block } from './sections/partnerBlock/partnerBlock';
import { renderer as plp_preview } from './sections/plpPreview/plpPreview';
import { renderer as preview_error } from './sections/previewError/previewError';
import { renderer as product_carousel } from './sections/productCarousel/productCarousel';
import { renderer as product_carousel_recommendations } from './sections/productCarouselRecommendations/productCarouselRecommendations';
import { renderer as section_title } from './sections/sectionTitle/sectionTitle';
import { renderer as standard_banner } from './sections/standardBanner/standardBanner';
import { renderer as video_block } from './sections/videoBlock/videoBlock';

export const renderers = {
  advanced_copy_block,
  button,
  content_tiles,
  copy_block,
  department_hero_banner,
  hero_carousel,
  links_block,
  page_carousel,
  partner_block,
  plp_preview,
  preview_error,
  membership_banner,
  product_carousel,
  product_carousel_recommendations,
  section_title,
  standard_banner,
  video_block,
};

export type ContentBlockRendererType = keyof typeof renderers;
